// ============================================================================
// Cliente API para /api/calificaciones (admin) y /api/public/calificacion
// (formulario público del comensal, sin login).
// ============================================================================
import { api } from './client';

export interface Calificacion {
  id: number;
  token: string;
  venta_id: number;
  sede_id: number;
  pedido_id: number | null;
  mesero_id: number | null;
  mesero: string | null;
  abierto_at: string | null;
  cerrado_at: string | null;
  items_resumen: string | null;
  total: number | null;
  q_atencion: number | null;
  q_comida: number | null;
  q_recomendacion: number | null;
  q_velocidad: number | null;
  q_limpieza: number | null;
  q_ambiente: number | null;
  comentario: string | null;
  estado: 'pendiente' | 'completada';
  created_at: string;
  respondida_at: string | null;
}

export interface CalificacionesStats {
  global: {
    emitidas: number;
    respondidas: number;
    atencion: number | null;
    comida: number | null;
    recomendacion: number | null;
    velocidad: number | null;
    limpieza: number | null;
    ambiente: number | null;
  };
  meseros: Array<{
    mesero: string;
    emitidas: number;
    respondidas: number;
    atencion: number | null;
    comida: number | null;
    recomendacion: number | null;
  }>;
}

/** Genera (o recupera) el token QR de calificación de una venta pagada. */
export const crearCalificacionQR = (ventaId: number) =>
  api.post<{ token: string; estado: string; nueva: boolean }>('/api/calificaciones', { venta_id: ventaId });

export const listCalificaciones = (q: { sede_id?: number; desde?: string; hasta?: string; limit?: number } = {}) => {
  const p = new URLSearchParams();
  if (q.sede_id) p.set('sede_id', String(q.sede_id));
  if (q.desde) p.set('desde', q.desde);
  if (q.hasta) p.set('hasta', q.hasta);
  if (q.limit) p.set('limit', String(q.limit));
  return api.get<Calificacion[]>(`/api/calificaciones${p.size ? `?${p}` : ''}`);
};

export const getCalificacionesStats = (q: { sede_id?: number; desde?: string; hasta?: string } = {}) => {
  const p = new URLSearchParams();
  if (q.sede_id) p.set('sede_id', String(q.sede_id));
  if (q.desde) p.set('desde', q.desde);
  if (q.hasta) p.set('hasta', q.hasta);
  return api.get<CalificacionesStats>(`/api/calificaciones/stats${p.size ? `?${p}` : ''}`);
};

// --- Endpoints públicos (comensal, sin login) ---

export const getPublicCalificacion = (token: string) =>
  api.get<{ ok: boolean; estado: 'pendiente' | 'completada'; sede_nombre: string }>(
    `/api/public/calificacion/${encodeURIComponent(token)}`
  );

export interface RespuestasCalificacion {
  q_atencion: number;
  q_comida: number;
  q_recomendacion: number;
  q_velocidad?: number | null;
  q_limpieza?: number | null;
  q_ambiente?: number | null;
  comentario?: string | null;
}

export const enviarCalificacion = (token: string, r: RespuestasCalificacion) =>
  api.post<{ ok: boolean }>(`/api/public/calificacion/${encodeURIComponent(token)}`, r);
